import { Link } from "@tanstack/react-router";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

export function SiteFooter() {
  const items = [
    { icon: Phone, text: "0493 100 265" },
    { icon: Mail, text: "sepremiumcabs@gmail.com" },
    { icon: MapPin, text: "Melbourne, Victoria" },
    { icon: Clock, text: "24/7 Service" },
  ];
  return (
    <footer className="border-t border-border/60 bg-background">
      <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-around gap-6 px-6 py-6">
        {items.map((it) => (
          <div key={it.text} className="flex items-center gap-2 text-sm">
            <it.icon className="h-4 w-4 text-primary" />
            <span className="text-muted-foreground">{it.text}</span>
          </div>
        ))}
      </div>
      <nav className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-center gap-x-6 gap-y-3 border-t border-border/40 px-6 py-5 text-xs font-semibold tracking-widest">
        <Link to="/" className="text-muted-foreground hover:text-primary">
          HOME
        </Link>
        <Link to="/melbourne-airport-taxi" className="text-muted-foreground hover:text-primary">
          MELBOURNE AIRPORT TAXI
        </Link>
        <Link to="/suburbs" className="text-muted-foreground hover:text-primary">
          MELBOURNE SUBURBS WE SERVE
        </Link>
        <Link to="/chauffeur-services" className="text-muted-foreground hover:text-primary">
          CHAUFFEUR SERVICES
        </Link>
        <Link to="/corporate-taxi" className="text-muted-foreground hover:text-primary">
          CORPORATE TAXI
        </Link>
        <Link to="/long-distance-taxi" className="text-muted-foreground hover:text-primary">
          LONG DISTANCE
        </Link>
        <Link to="/blog" className="text-muted-foreground hover:text-primary">
          GUIDES
        </Link>
        <Link to="/contact" className="text-muted-foreground hover:text-primary">
          CONTACT
        </Link>
      </nav>
      <div className="pb-6 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} SE Premium Cabs · sepremiumcabs.com
      </div>
    </footer>
  );
}